var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component rich-editor"},[_c('quill-editor',{ref:"editor",class:{'default-height':!_vm.disabled},attrs:{"content":_vm.value,"disabled":_vm.disabled,"options":_vm.editorOption},on:{"change":function($event){return _vm.handleInput($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }